module.exports = __webpack_public_path__ + "static/img/kefu_btn.f9f32e98.png";